import { osName, getUA, isIOS, isAndroid, osVersion, isWindows } from 'react-device-detect'
import DownloadClicEvent from '../components/Analytics/DownloadClickEvent';
// Reverting sign in button + web app access
// export const redirectToWeb = (e) => {
//     e.preventDefault();
//     window.open('https://web.bluemail.me/?utm_sid=website1', "_blank").focus();
// }

export const redirectToStore = (e) => {
    e.preventDefault();
    if (isIOS || getUA.includes('iPad')) {
        DownloadClicEvent('iOS')
        window.open('https://apps.apple.com/us/app/blue-mail-email-mailbox/id1063729305', "_blank")
    } else if (osName === 'Windows' || isWindows) {
        let version = getDownloadUrlByOsVersion()
        DownloadClicEvent('Windows')
        window.open(version)
    } else if (isAndroid) {
        DownloadClicEvent('Android')
        window.open('https://play.google.com/store/apps/details?id=me.bluemail.mail', "_blank")
    } else if (osName === 'Mac OS') {
        DownloadClicEvent('Mac')
        window.open('https://apps.apple.com/us/app/bluemail/id1458754578?mt=12', "_blank")
    } else if (getUA.includes('Silk')) {
        DownloadClicEvent('Amazon')
        window.open('https://www.amazon.com/BlueMail-Inc/dp/B01DUUITZO', "_blank")
    }else if (getUA.includes('Linux')) {
        DownloadClicEvent('Linux')
        window.open('https://snapcraft.io/bluemail', "_blank")
    }else {
        DownloadClicEvent('Android')
        window.open('https://play.google.com/store/apps/details?id=me.bluemail.mail', "_blank")
    }
}

export const getDownloadUrlByOsVersion = () => {
    let version = osVersion.split('.');
    version = version[0];
    if (version > 9) {
        return 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl';
    } else {
        return 'download.bluemail.me/BlueMail/BlueMail-1.140.34.exe';
    }
}


export const isWindows7 = () => {
    let version = osVersion; 
    if(osVersion.includes('.')){
        version = osVersion.split('.');
        version = version[0];
    }
    if (isWindows && (version  === 7 || version  === '7')) {
        return true;
    } 
    return false;
}
